import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_fontlist, update_fontlist } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './fontlistform.css';

export const FontListForm = ({ title }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
  const [fontList, setFontList] = useState({
    name: state ? state.name : "",
    isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
    // isActive: state ? state.isActive == undefined ? false : state.isActive : false,
  });
  const [imgObj, setImgObj] = useState({ smallPreviewFont: state ? state.smallPreview : "", largePreviewImgFont: state ? state.largePreviewImg : "", fontFile: state ? state.fontFile : "" });

  const handleChange = (e) => {
    if (e.target.name === 'fontListCategory' || e.target.name === "fontListTag") {
      let fontListCategoryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
      setUpdatedData({ ...updatedData, [e.target.name]: fontListCategoryAry })
      setFontList({ ...fontList, [e.target.name]: fontListCategoryAry });
    } else {
      setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
      setFontList({ ...fontList, [e.target.name]: e.target.value });
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files[0].size > 5242880) {
      toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
    } else {
      setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
      setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
      setFontList({ ...fontList, [e.target.name]: e.target.files[0] });
    }
  };

  let handleSwitch = (e) => {
    setUpdatedData({ ...updatedData, [e.target.name]: fontList[e.target.name] ? false : true });
    setFontList({ ...fontList, [e.target.name]: fontList[e.target.name] ? false : true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      return;
    };
    let createUpdateFontList;
    setIsLoading(true);
    if (state) {
      createUpdateFontList = await update_fontlist(updatedData, state._id)
    } else {
      // console.log("==========fontList==========", fontList);
      createUpdateFontList = await add_fontlist(fontList)
    }
    setIsLoading(false);
    if (createUpdateFontList) {
      const { message, status } = createUpdateFontList;
      if (status) {
        toast.success(message);
        navigate("/fontList");
        setFontList({
          name: "",
          isPremium: false,
          isActive: false,
        });
        setImgObj({ smallPreviewFont: "", largePreviewImgFont: "", fontFile: "" });
        setUpdatedData({});
        setValidated(false);
      } else {
        toast.error(message);
      };
    }

    // var allFieldDone = [];
    // Object.keys(fontList).map(async (fieldName, i) => {
    //   if (fieldName !== 'id') {
    //     if (fontList[fieldName].toString().length > 0) {
    //       // if (fieldName === "fontFile") {
    //       //   if (fontList.fontFile.type.split('/')[1] !== 'x-zip-compressed') {
    //       //     allFieldDone.push(false);
    //       //     toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is must be a zip file!!`);
    //       //   } else {
    //       //     allFieldDone.push(true);
    //       //   }
    //       // } else {
    //       allFieldDone.push(true);
    //       // }
    //     } else {
    //       allFieldDone.push(false);
    //       toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
    //     }
    //   }
    // });
    // if (!state) {
    //   Object.keys(imgObj).map(async (fieldName, i) => {
    //     if (!imgObj[fieldName]) {
    //       allFieldDone.push(false);
    //       toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
    //       return allFieldDone;
    //     } else {
    //       allFieldDone.push(true);
    //     }
    //   });
    // }

    // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
    // if (aalFieldDone) {
    //   let createUpdateFontList;
    //   setIsLoading(true);
    //   if (state) {
    //     createUpdateFontList = await update_fontlist(fontList, state._id)
    //   } else {
    //     // console.log("==========fontList==========", fontList);
    //     createUpdateFontList = await add_fontlist(fontList)
    //   }
    //   setIsLoading(false);
    //   if (createUpdateFontList) {
    //     const { message, status } = createUpdateFontList;
    //     if (status) {
    //       toast.success(message);
    //       navigate("/fontList");
    //       setFontList({
    //         id: "",
    //         name: "",
    //         isPremium: false,
    //         isActive: false,
    //       });
    //       setImgObj({ smallPreviewFont: "", largePreviewImgFont: "", fontFile: "" });
    //     } else {
    //       toast.error(message);
    //     };
    //   }
    // }
  };

  useEffect(() => {
    document.title = `Emoji Keyboard | ${title}`;
    setUpdatedData({});
  }, []);

  return (
    <div className='addslider-main p-3'>
      <div className='sliders-header mb-3 d-flex justify-content-between'>
        <h3>{state ? `Edit Font List` : `Add Font List`}</h3>
      </div>
      <Row>
        <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
          <Row className='flex-column'>
            <Col className='mb-3'>
              <h6 className='mb-1'>Small Preview : </h6>
              <img className='w-100' src={`${imgObj.smallPreviewFont ? imgObj.smallPreviewFont : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : fontList.name} />
            </Col>
            <Col className='mb-3'>
              <h6 className='mb-1'>Large Preview : </h6>
              <img className='w-100' src={`${imgObj.largePreviewImgFont ? imgObj.largePreviewImgFont : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : fontList.name} />
            </Col>
          </Row>
        </Col>
        <Col md={8} lg={9}>
          <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
            <Row className='mb-3'>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='fontList_name' column md={3} sm={4}>Name</Form.Label>
                <Col><Form.Control id='fontList_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : fontList.name} required /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='fontList_smallPreviewFont' column md={3} sm={4}>Small Preview</Form.Label>
                <Col><Form.Control id='fontList_smallPreviewFont' type="file" accept='image/*' name='smallPreviewFont' onChange={handleFileInput} required={state ? false : true} /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='fontList_largePreviewImgFont' column md={3} sm={4}>Large Preview Img</Form.Label>
                <Col><Form.Control id='fontList_largePreviewImgFont' type="file" accept='image/*' name='largePreviewImgFont' onChange={handleFileInput} required={state ? false : true} /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='fontList_fontFile' column md={3} sm={4}>Font File</Form.Label>
                <Col><Form.Control id='fontList_fontFile' type="file" name='fontFile' accept='.ttf' onChange={handleFileInput} required={state ? false : true} /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='fontList_isPremium' column md={3} sm={4}>Premium</Form.Label>
                <Col><Form.Check type="switch" id="fontList_isPremium" name='isPremium' onChange={handleSwitch} checked={fontList.isPremium} role="button" /></Col>
              </Col>
              {/* <Col lg={6} className="mb-3">
                <Row className='align-items-center'>
                  <Form.Label htmlFor='fontList_isActive' column md={3} sm={4}>Active</Form.Label>
                  <Col><Form.Check type="switch" id="fontList_isActive" name='isActive' onChange={handleSwitch} checked={fontList.isActive} role="button" /></Col>
                </Row>
              </Col> */}
            </Row>
            <Row className='justify-content-end'>
              <Col lg={12}>
                <Col lg={3} md={3} sm={4}></Col>
                <Col>
                  <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                  </Button>
                  {/* <Link to=""> */}
                  <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                  {/* </Link> */}
                </Col>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

FontListForm.defaultProps = {
  title: "Font List Form"
}

export default FontListForm